module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-6-3c93c21e3a58ce284586c43b21d84c2c.jpg";